
import webApi from './webApi'


const basePath = 'reasons'

const reasonService = {
    fetchAll : async()=>{
        return await webApi.httpGet(basePath)
    },
    
    fetch : async(id)=>{
        return await webApi.httpGet(basePath+'/'+id)
    },

    create : async(user)=>{
        return await webApi.httpPost(basePath, user)
    },
    update : async(user)=>{
        return await webApi.httpPut(basePath, user)
    },

    delete : async(id)=>{
        return await webApi.httpDelete(basePath+'/'+id)
         
    },
}



export default reasonService

